const SiteFooterMotion = () => {
  const components = document.querySelectorAll('[data-component-site-footer]');
  components.forEach((component) => {
    const timeline = gsap.timeline({paused: true});
    timeline.fromTo(component, {
      opacity: 0,
    }, {
      opacity: 1,
      ease: 'power3.out',
      duration: 0.5,
    });

    setupComponentScrollTrigger(component, timeline);
  });
};

SiteFooterMotion();